import { removeToken } from "../utils/getToken";
import service from "../utils/service";
import allPaths from "../route/allPaths";

const logout = async () => {
  try {
    await service.delete("v4/users/sign_out");
  } catch (error) {
    console.error("Logout API failed:", error);
  } finally {
    removeToken();
    localStorage.removeItem("CW_JWT_TOKEN");
    sessionStorage.clear();

    try {
      const response = await service.get("v4/configs/auth");

      const auth = response?.data?.auth;
      const cognito = auth?.cognito;
      const logoutRedirect = auth?.logout_redirect_uri;
      if (cognito?.enabled) {
        const logoutUrl =
          `${cognito.user_pool_site}/logout` +
          `?client_id=${cognito.client_id}` +
          `&logout_uri=${encodeURIComponent(logoutRedirect)}`;

        window.location.href = logoutUrl;
        return;
      }

      if (logoutRedirect) {
        window.location.href = logoutRedirect;
        return;
      }

    } catch (e) {
      console.error("Failed to fetch auth config", e);
    }

    window.location.replace(allPaths.LOGIN_ROUTE);
  }
};

export default logout;